module.exports = __webpack_public_path__ + "img/admission-banner-2.80cfbd96.png";